export default __webpack_public_path__ + "static/media/loading.18011e4e.gif";